export default __webpack_public_path__ + "static/media/39_photo.c08f7bf0.jpg";